import {Component, OnInit, ViewContainerRef} from "@angular/core";
import {FUISpinnersService} from "./spinners.service";

@Component({
    selector: "fui-spinners",
    templateUrl: "./spinners.component.html"
})
export class FUISpinnersComponent implements OnInit {
    constructor(private spinnersService: FUISpinnersService,
                private viewContainerRef: ViewContainerRef) {
        this.spinnersService.setPlaceholder(this.viewContainerRef);
    }

    ngOnInit() {
        this.spinnersService.create();
    }
}
